const COMMON = {
  PROFILE: {
    SETTINGS: {
      TITLE: "تنظیمات شخصی",

      TELEGRAM_BOT: "ربات تلگرام",
      TELEGRAM_DES:
        "از این قسمت میتوانید ربات تلگرام خود را فعال یا غیرفعال کنید.",
      ENABLED: "فعال",
      DISABLED: "غیر فعال",
      PEND_FOR_CONFIRM: "در انتظار تایید",
      ENABLE: "فعالسازی",
      DISABLE: "غیر فعال کردن",
      CONFIRM_ACTIVATION: "در انتظار تایید",

      LANG: "زبان",
      LANG_DES: "از این قسمت میتوانید زبان پنل گفتگو را تغییر دهید.",
      LANG_SELECT_DEFAULT_OP: "یک زبان انتخاب کنید",
      FA_LANG: "فارسی",
      EN_LANG: "انگلیسی",

      NAME: "نام",
      NAME_DES: "نام نمایش داده شده به بازدید کننده در قسمت ابزارک مکالمه",
      NAME_PH: "نام خود را وارد کنید.",

      AGENT_TITLE: "عنوان",
      AGENT_TITLE_DES:
        "در صورت وارد کردن عنوان ، پایین نام اپراتور در قسمت ابزارک مکالمه به کاربر نمایش داده میشود",
      AGENT_TITLE_PH: "عنوان",

      EMAIL: "ایمیل",
      EMAIL_DES:
        "از این ایمیل برای ورود به قسمت مدیریت اصلی و اپلیکیشن تحت وب استفاده میشود ، همچنین اعلانات به این ایمیل ارسال میشود",
      EMAIL_PH: "",

      PASSWORD: "رمز عبور",
      PASSWORD_DES:
        "رمز عبور بایستی حداقل ۶ کاراکتر بوده و از شماره و حروف کوچک و بزرگ و بدون فاصله (space) استفاده شود.",
      PASSWORD_PH: "رمز عبور خود را وارد کنید",

      AVATAR: "عکس پروفایل",
      AVATAR_DES:
        "عکس پروفایل شما که برای کاربرانی که با آنها مکالمه می کنید نمایش داده میشود",
      BROWSE_IMAGE: "انتخاب تصویر",
      DELETE_IMAGE: "حذف تصویر",
      AVATAR_UPLOAD_HINT: "حجم تصویر حداکثر میتواند 500 کیلوبایت باشد",

      THEME: "تغییر پوسته",
      THEME_DES:
        "پوسته اپ گفتگوتون رو شخصی سازی بکنید. تغییرات را فقط شما مشاهده خواهید کرد.",
      DARK_MODE: "حالت شب",
      LIGHT_MODE: "روز روشن",
      ACCOUNT_SETTINGS: "تنظیمات اکانت",

      COMING_SOON: "به زودی",
      EXIT: "خروج از اکانت",
      SUBMIT: "ذخیره تغییرات",
    },
    ALARMS: {
      TITLE: "هشدارها",

      ALARM_ACTIVATION: "فعال بودن صداهای هشدار",
      ALARM_ACTIVATION_DES:
        "با فعال کردن این گزینه هشدار ها برای شما فعال خواهد شد.",
      NEW_MSG_SOUND: "صدا های پیام جدید",
      NEW_VISTOR_SOUND: "صدا های بازدید کننده جدید",
      NEW_MSG_IN_CONV_SOUND: "صدای دریافت پیام هنگام مکالمه",
    },
    ACTIVATE_BROWSER_NOTIF: "فعالسازی اعلان‌های مرورگر",
    EXIT: "خروج",
    CLOSE: "بستن",
    SUBMIT: "ذخیره تغییرات",
  },
  MODAL: {
    DELETE_PENDINGS_CONFIRM: "همه مکالمات در حال انتظار پاک شوند؟",
    DELETE_ONGOINGS_CONFIRM: "همه مکالمات بسته شوند؟",
    ADD_TO_BLACK_LIST_TITLE: "انتقال کاربر به لیست سیاه",
    ADD_TO_BLACK_LIST_FOR: "انتقال کاربر به لیست سیاه به مدت:",
    BAN_FOR_ONE_DAY: "یک روز",
    BAN_FOR_ONE_WEEK: "یک هفته",
    BAN_FOR_ONE_MONTH: "یک ماه",
    BAN_FOR_ONE_ALWAYS: "همیشه",
    CLOSE_CONV_CONFIRM: "این مکالمه بسته شود؟",
    REJECT_CONV_CONFIRM: "این مکالمه رد شود؟",
    LOGOUT_CONFIRMATION: "آیا مطمئن هستید که میخواهید خارج شوید؟",
    DELETE_SHORTCUT_MSG_CONFIRM: "آیا از حذف پیام اطمینان دارید؟",
    PACKAGE_EXPIRE:
      "همراه رایچتی پکیج رایچت شما منقضی شده لطفابه ادمین خود اطلاع دهید تا جهت ارتقا و یا تمدید پکیج اقدام کنند.",
    TRANSFER_CONV_TITLE: "انتقال گفتگو",
    TRANSFER_CONV_CONFIRM: "آیا از انتقال این گفتگو اطمینان دارید ؟",
    BUY_AND_RENEWAL: "خرید/تمدید",
    CANCEL: "انصراف",
    CONFIRM: "تایید",
    CLOSE: "بستن",
  },
  FORM_ERRORS: {
    FIELD_REQUIRED: "این فیلد نمیتواند خالی باشد",
    INVALID_EMAIL: "فرمت ایمیل صحیح نمی باشد",
    INVALID_PASSWORD: "رمز عبور معتبر نمی باشد",
  },

  FILE_PREVIEW: {
    NOT_SUPPORTING_MSG: "فایل مورد نظر پشتیبانی نمیشود.",
    CLOSE: "بستن",
    CANCEL: "انصراف",
    ARE_YOU_SURE: "آیا از ارسال فایل مطمئن هستید؟",
    CONFIRM: "تایید",
  },

  SPECIAL_MSG_TYPES: {
    IMAGE: "عکس",
    AUDIO: "پیام صوتی",
    FILE: "پیوست",
  },

  BROWSER_NOT_SUPPOR_VIDEO_FILES:
    "مرورگر شما فایل ویدئویی را پشتیبانی نمی‌کند.",

  BTN_DISABLED_PURCHASE_LINK_TITLE: "خرید",
  BTN_DISABLED_TOOLTIP_TEXT:
    "برای استفاده از این فیچر نیاز به تهیه پکیج #package# دارید. ",

  PACKAGES: {
    PREMIUM: "پریمیوم",
    COMMERCIAL: "تجاری",
    BASIC: "پایه",
  },

  POPUP_MESSAGE: {
    CLOSE_DEFAULT: "بستن",
    NEVER_SHOW_DEFAULT: "دیگه این پیام رو نمایش نده",
  },

  MINUTES: "#minute# دقیقه",
  SECONDS: "#second# ثانیه",
  HOURS: "#hour# ساعت",
  TO_USE_YOU_SHOULD_UPGRADE:
    "جهت استفاده از این ویژگی، لطفا پکیج خود را ارتقا دهید.",
  UPGRADE_LINK: "لینک ارتقا",

  ACTIVATE: "فعالسازی",
  RENEW: "تمدید",

  DO_NOT_SHOW_MSG_AGAIN: "دیگه این پیام رو نمایش نده",

  PACKAGE_UPGRADE: "تمدید و ارتقا",
};

export default COMMON;
